
/// <amd-module name="Search/Shared/Components/PivotCommands/Commands.Props" />
import { ObservableValue } from "VSS/Core/Observable";
import { IHeaderCommandBarItem } from "VSSUI/HeaderCommandBar";

export interface IPivotCommands {
    farItems: IHeaderCommandBarItem[];

    items: IHeaderCommandBarItem[];
}

export interface IPivotCommandProps {
    pivotCommands: ObservableValue<IPivotCommands>;
}

